import { useMemo, useState, useCallback, useEffect } from 'react';
import {
	ToothRestorationType,
	ToothSurface,
} from '../../../../../graphql/graphql';
import { useDENTContext } from '../../../Services/DENTContext';
import useTooth from '../useTooth';
import { SurfaceOperation } from '../../../Enums/SurfaceOperation.enum';
import { RESTORATION_ITEMS_SURFACES } from '../../../Components/DENTModalOverviewRestoration/restorationItemsSurfaces';

export default function useToothRestorationFillingSurfaces() {
	const [showedSurfaces, setShowedSurfaces] = useState<ToothSurface[]>(
		RESTORATION_ITEMS_SURFACES[ToothRestorationType.Filling],
	);

	const { activeTooth } = useDENTContext();
	const {
		restoration: { fillings },
	} = useTooth();

	const [fillingIndex, setFillingIndex] = useState(
		activeTooth?.restoration?.fillings?.length ?? 0,
	);

	useEffect(() => {
		const fillingsLength = activeTooth?.restoration?.fillings?.length ?? 0;
		if (fillingIndex >= fillingsLength) {
			setFillingIndex(fillingsLength);
		}
	}, [activeTooth?.restoration?.fillings?.length, fillingIndex]);

	const selectedSurfaces = useMemo(() => {
		return fillings?.getSurfaces(fillingIndex) ?? [];
	}, [fillings, fillingIndex, activeTooth]);

	const handleSelectSurface = useCallback(
		(surfaces: ToothSurface[], operation: SurfaceOperation) => {
			fillings?.setSurfaces(fillingIndex, surfaces, operation);
		},
		[fillings, fillingIndex],
	);

	return {
		showedSurfaces,
		setShowedSurfaces,
		selectedSurfaces,
		handleSelectSurface,
		fillingIndex,
		setFillingIndex,
	} as const;
}
